import process from 'process';

import { Buffer } from 'buffer';

declare global {
  interface Window {
    Buffer?: typeof Buffer;
    process?: typeof process;
    global?: typeof globalThis;
  }
}

// Vite 7 + Rolldown doesn't reliably inject node globals in dev.
// Keep this file imported first in the app entry.
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

if (typeof (globalThis as any).process === 'undefined') {
  (globalThis as any).process = process;
}

if (typeof (globalThis as any).global === 'undefined') {
  (globalThis as any).global = globalThis;
}
